
import React, { useEffect } from "react"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import NextIcon from "./indent-icon.png";
import PolicesData from "./data.json"
import "./PrivacyPolicyPage.scss"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"

export default function PrivacyPolicyPage() {
    useTitle("Privacy Policy - The Movie House TV")
    useEffect(() => {
        ReactGA.send("pageview")
    })

    return (
        <TMHBanner classOption="only-gradient policy-page" isLogged={false}>
            <div className="policyPage">
                <div className="policyPage__header">
                    <h1>{PolicesData.title}</h1>
                    <h5>{PolicesData.subTitle}</h5>
                    {PolicesData.description.map((item, index) => (
                        <p key={`policy-description-${index}`}>{item}</p>
                    ))}
                </div>
                <div className="breakLine"></div>
                {PolicesData.policy.map((policy, index) => (
                    <div key={`policy-item-${index}`}>
                        <p className="question">{policy.question}</p>
                        {policy.answer.map((answer, index) => {
                            if (typeof (answer) === "object") {
                                return (answer.map((bullet, index) => (
                                    <div className="bulletItem" key={`policy-bullet-${index}`}>
                                        <img src={NextIcon} alt="next-icon" />
                                        <p>{bullet}</p>
                                    </div>
                                ))
                                )
                            }
                            else {
                                return answer.includes("www.dataoptoutsubmission.com") ? <p className="term-text" key={`policy-answer-${index}`} dangerouslySetInnerHTML={{ __html: answer }} /> : <p key={`policy-answer-${index}`}>{answer}</p>
                            }
                        })}

                        <div className="breakLine" />
                    </div>
                ))}
                <p className="question">Questions?</p>
                <p>If you have any questions or comments about this Privacy Policy, contact us through the <a style={{color: "white"}} href="/tmh/#/contact-us" target="_blank">Contact page</a>.</p>
                <nav className="policyPage__footer">
                    <a href="/tmh/#/privacy-policy" target="_blank">
                        Privacy policy
                    </a>
                    <a href="/tmh/#/terms-conditions" target="_blank">
                        Terms &#38; conditions
                    </a>
                    <a href="/tmh/#/about" target="_blank">
                        About The Movie House
                    </a>
                </nav>
            </div>
        </TMHBanner>
    )
}
